<template>
  <div>
    <l-map
      @update:center="centerUpdated"
      v-if="!loading"
      ref="map"
      :zoom="zoom"
      :center="center"
      class="map"
    >
      <!-- <div class="main-search"> -->
      <!-- <div style="left: 50% !important" class="searchGeo">
        <i class="far fa-search"></i>
        <input
          type="text"
          v-model="searchTerm"
          v-on:keyup.enter="geoQuerySearch()"
          v-on:keyup.escape="searchResults = []"
          placeholder="Busca una dirección o ingresa las coordenadas"
        />
        <transition name="slide" appear>
          <div v-if="searchResults.length" class="matches">
            <ul>
              <li
                v-for="result in searchResults"
                :key="result.properties.osm_id"
                @click="geoQuerySelect(result)"
              >
                <i class="fas fa-map-marker-alt"></i> {{ result.name }}
              </li>
            </ul>
          </div>
        </transition>
      </div> -->
      <!-- </div> -->
      <l-tile-layer :url="url" :attribution="attribution" />

      <l-marker
        :draggable="true"
        @update:lat-lng="positionUpdated"
        :lat-lng="center"
        :icon="getImage"
      >
      </l-marker>
      <!-- <v-geosearch class="search" :options="geosearchOptions"></v-geosearch> -->
      <l-geo-json
        :options-style="styleFunction"
        :options="options"
        :geojson="geojson"
      />
    </l-map>
  </div>
</template>

<script>
import { db } from "@/firebase";
import L from "leaflet";

import { latLng } from "leaflet";
require("leaflet-routing-machine");
require("leaflet-control-geocoder");

// import "leaflet/dist/leaflet.css";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import VGeosearch from "vue2-leaflet-geosearch";

import {
  LMap,
  LTileLayer,
  LControlZoom,
  LMarker,
  LPopup,
  LTooltip,
  LGeoJson,
} from "vue2-leaflet";

export default {
  name: "zone-validation",
  props: ["latitude", "longitude"],
  components: {
    LMap,
    LTileLayer,
    LControlZoom,
    LMarker,
    LPopup,
    LTooltip,
    LGeoJson,
    VGeosearch,
  },
  data() {
    return {
      loading: true,
      polygons: [],
      searchResults: [],
      geosearchOptions: {
        // showMarker: false,
        provider: new OpenStreetMapProvider(),
        resultFormat: ({ result }) => result.label,
        style: "bar",
        animateZoom: true,
        autoClose: true,
        searchLabel: "Buscar",
      },
      zoom: 18,
      center: latLng(14.075104529559956, -87.19571461307869),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      map: null,
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: false,
      },
      geojson: null,
      fillColor: "#ff0000",
      geoCoder: null,
      searchTerm: "",
    };
  },

  computed: {
    getImage() {
      return L.icon({
        iconUrl: require("@/assets/avatar-default.png"),
        shadowUrl: require("@/assets/map-marker.png"),
        iconSize: [32, 32],
        iconAnchor: [10, 39],
        shadowAnchor: [26, 45],
        popupAnchor: [-3, -76],
      });
    },
    options() {
      return {
        onEachFeature: this.onEachFeatureFunction,
      };
    },
    styleFunction() {
      const fillColor = this.fillColor;
      return () => {
        return {
          weight: 2,
          color: "#ff0000",
          opacity: 0.1,
          fillColor: fillColor,
          fillOpacity: 0.1,
        };
      };
    },
  },

  methods: {
    geoQuerySelect(e) {
      this.center = e.center;
      this.searchResults = [];
      this.searchTerm = "";
    },
    positionUpdated(e) {
      this.center = [e.lat, e.lng];
      this.$emit("updated", this.center);
    },
    centerUpdated(e) {
      this.center = [e.lat, e.lng];
      this.$emit("updated", this.center);
    },
    async init() {
      await this.$binding(
        "globals",
        db.collection(`settings`).doc("global")
      ).then(async (globals) => {
        this.geojson = JSON.parse(globals.coverageZone);

        this.geojson.features = this.geojson.features.filter(
          (e) => e.properties.color != "transparent"
        );
      });
      this.loading = false;
    },
    geoQuerySearch() {
      this.map = this.$refs.map.mapObject;

      this.geoCoder = L.Control.geocoder({
        geocoder: this.useGoogleSearch
          ? new L.Control.Geocoder.Google(process.env.VUE_APP_MY_WEB_API_KEY)
          : "",

        defaultMarkGeocode: false,
      })

        .on("startgeocode", (e) => {
          // this.$store.commit("setLoading", "Buscando coincidencias...");
        })
        .on("finishgeocode", (e) => {
          if (e.results.length > 0) {
            this.searchResults = e.results;
          }
        })
        .addTo(this.map);

      this.searchResults = [];

      if (this.searchTerm) {
        var re =
          /[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)/;
        let result = re.exec(this.searchTerm);

        if (result && result.length) {
          this.geoCoder.setQuery(result[0]);
          this.geoCoder._geocode();
        } else {
          this.geoCoder.setQuery(
            `Honduras, ${this.city ? this.city.name : ""} ,${this.searchTerm}`
          );
          this.geoCoder._geocode();
        }
      }
    },
  },

  async mounted() {
    this.center = latLng(this.latitude, this.longitude);

    this.init();
  },
};
</script>

<style>
.map {
  height: 40vh !important;
  position: relative;
}

.leaflet-control-geocoder {
  display: none !important;
}

.searchGeo {
  z-index: 450;
}
</style>
